module.exports = __webpack_public_path__ + "img/borrow.a3b8ba7f.png";